import type { UseAsyncActions } from "@react-hookz/web";
import { useEffect } from "react";

export function useAutoFetch<T>(
    action: UseAsyncActions<T, any[]>,
    enabled: boolean = false,
): void {
    useEffect(() => {
        if (enabled) {
            void action.execute();
        }
    }, [enabled, action]);
}
